var map = {
	"./appeal.png": 9432,
	"./attachment.svg": 6264,
	"./candidate.svg": 1398,
	"./career.png": 4019,
	"./conducted.svg": 2138,
	"./contract.png": 2939,
	"./discipline.png": 7559,
	"./exit.png": 5181,
	"./grievance.png": 6637,
	"./leave.png": 4168,
	"./pasted image 0.png": 1809,
	"./payroll.png": 5894,
	"./pdf.png": 5235,
	"./profile.png": 486,
	"./question.svg": 8335,
	"./rbm.png": 6376,
	"./recruitment.png": 1263,
	"./reporting.png": 411,
	"./s-l140.jpg": 4064,
	"./structure.png": 1034,
	"./talent.png": 5583,
	"./test.svg": 1439,
	"./training.png": 2016,
	"./voting.png": 3840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5297;